export default "__VITE_ASSET__CEkQ25BV__"